import { actionCreatorFactory } from 'typescript-fsa';
import { IServer } from '@cbridge-packages/server';

export namespace ServersFilterAction {
  const actionCreator = actionCreatorFactory('ServersFilter');

  export const select = actionCreator<{ serverId: IServer['serverId'] }>('SELECT');
  export const toggleSelect = actionCreator<{ serverId: IServer['serverId'] }>('TOGGLE_SELECT');
  export const clearSelect = actionCreator('CLEAR_SELECT');

  export const destroy = actionCreator('DESTROY');
}
